import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Multiple approaches to ensure immediate scroll to top
    
    // Method 1: Immediate scroll with instant behavior
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    
    // Method 2: Force scroll position using direct property
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Method 3: Use requestAnimationFrame to ensure it happens before render
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
    
  }, [pathname]);

  // Also handle it during component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}

export default ScrollToTop;
